import { Plus, Trash2 } from "lucide-react";
import EventNameSelect from "@/components/order/EventNameSelect";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SectionTitle } from "@/components/order/AthleteFields";

export default function EventsFields({ events, setEvents, days, emptyEvent, eventOptions = [] }) {
  const update = (i, k, v) => setEvents(events.map((e, j) => (j === i ? { ...e, [k]: v } : e)));
  return (
    <section>
      <SectionTitle n="2">Mata Lomba & Foto Pilihan</SectionTitle>
      <p className="text-sm text-neutral-400 mb-4">Tambahkan setiap mata lomba (maks. 4). Tulis nama file foto dari Google Drive, pisahkan dengan koma.</p>
      <div className="space-y-4">
        {events.map((ev, i) => (
          <div key={i} data-testid={`event-row-${i}`} className="border border-white/10 bg-[#121212] p-4 sm:p-5">
            <div className="flex items-center justify-between mb-3">
              <p className="font-display uppercase font-bold text-lg text-[#FF5A00]">Mata Lomba {i + 1}</p>
              {events.length > 1 && (
                <button type="button" onClick={() => setEvents(events.filter((_, j) => j !== i))} data-testid={`remove-event-${i}`} className="text-neutral-400 hover:text-red-400 transition-colors">
                  <Trash2 className="w-4 h-4" />
                </button>
              )}
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Nama Mata Lomba</Label>
                <EventNameSelect value={ev.name} onChange={(v) => update(i, "name", v)} options={eventOptions} taken={events.map((e) => e.name)} testId={`event-name-input-${i}`} className="h-11 bg-[#0a0a0a]" />
              </div>
              <div className="space-y-2">
                <Label>Galeri / Hari</Label>
                <Select value={ev.day} onValueChange={(v) => update(i, "day", v)}>
                  <SelectTrigger data-testid={`event-day-select-${i}`} className="h-11 bg-[#0a0a0a]"><SelectValue placeholder="Pilih hari" /></SelectTrigger>
                  <SelectContent>
                    {days.map((d) => <SelectItem key={d.key} value={d.label} data-testid={`event-day-option-${i}-${d.key}`}>{d.label}</SelectItem>)}
                  </SelectContent>
                </Select>
              </div>
              <div className="space-y-2 sm:col-span-2">
                <Label>Nama File Foto yang Dipilih</Label>
                <Textarea required placeholder="cth. DSC_0123.jpg, DSC_0145.jpg" value={ev.photos} onChange={(e) => update(i, "photos", e.target.value)} data-testid={`event-photos-input-${i}`} className="bg-[#0a0a0a]" />
              </div>
            </div>
          </div>
        ))}
      </div>
      {events.length < 4 && (
        <button type="button" onClick={() => setEvents([...events, { ...emptyEvent }])} data-testid="add-event-btn"
          className="mt-4 w-full border border-dashed border-white/20 hover:border-[#FF5A00] hover:text-[#FF5A00] transition-colors py-3 flex items-center justify-center gap-2 font-display uppercase font-bold">
          <Plus className="w-4 h-4" /> Tambah Mata Lomba
        </button>
      )}
    </section>
  );
}
